import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';
import i18next from 'i18next';

export const BestSellersSettings = (props) => {
    const { settings, handleSettingsUpdate } = props;

    return (
        <Form className="settings">
            <Form.Field>
                <label>{i18next.t('smartPromotions.bestsellers.settings.top')}</label>
            </Form.Field>
            <div style={{ display: 'flex' }}>
                <Input placeholder={i18next.t('smartPromotions.bestsellers.settings.topPlaceholder')}
                    value={settings.top}
                    onChange={(e, { value }) => {
                        handleSettingsUpdate({ ...settings, top: value });
                    }}
                />
            </div>
            <Form.Field>
                <label>{i18next.t('smartPromotions.bestsellers.settings.minPrice')}</label>
            </Form.Field>
            <div style={{ display: 'flex' }}>
                <Input placeholder={i18next.t('smartPromotions.bestsellers.settings.minPricePlaceholder')}
                    value={settings.minPrice}
                    onChange={(e, { value }) => {
                        handleSettingsUpdate({ ...settings, minPrice: value });
                    }}
                />
            </div>
        </Form>
    );
};

BestSellersSettings.propTypes = {

    handleSettingsUpdate: PropTypes.func,
    settings: PropTypes.object
};